import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { renderRoutes } from 'react-router-config';
import { deleteAllCookies } from 'libs/auth';

export default class ClearStorage extends Component {
  componentWillMount() {
    localStorage.clear();
    deleteAllCookies();
  }

  render() {
    const { route } = this.props;
    return (
      <div>
        {renderRoutes(route.routes)}
      </div>
    );
  }
}

ClearStorage.propTypes = {
  route: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/RouteWrappers/ClearStorage.jsx